<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong>Manage Career Center &amp; Staff Requests</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBack">Back</button>
        </div>
      </div>
      <span style="font-size:14px">
        Manage and monitor any requests that you have sent to Career Centers
        within your area and even further as well as the requests that Staff
        send out to you! Reach out to Career Centers in the hope to be assigned
        a staff, or find the Career Center you already have a connection with
        and be assigned your staff.
      </span>
    </div>
    &nbsp;
    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <el-row :gutter="20" class="section-title">
          <el-col :xl="18" :lg="18" :md="18" :sm="24" :xs="24">
            <h6>Staff Connection Requests</h6>
          </el-col>
          <el-col
            class="page-subtext"
            :xl="5"
            :lg="5"
            :md="5"
            :sm="24"
            :xs="24"
          >
            <span style="font-size:14px"
              >Currently {{ SearchVisibility }} in searches</span
            >
          </el-col>
        </el-row>
        <p style="padding: 10px;">
          View all the connection requests sent to you by Staff wanting to help
          you along your career path and find that perfect new job. Feel free to
          accept or decline any staff requests and change your visibility to
          staff searches here.
        </p>
        <el-table
          ref="multipleTable"
          :data="this.CaseWorkerRequests"
          stripe
          height="265"
          style="width:100%; margin-top:-20px"
          v-if="!showNoData"
        >
          <el-table-column
            sortable
            property="caseWorkerName"
            label="Staff Name"
            width="200"
          >
          </el-table-column>
          <el-table-column
            sortable
            property="agencyName"
            label="Career Center Name"
            width="200"
          >
          </el-table-column>
          <el-table-column
            property="zipCode"
            label="Zip Code"
            width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="distance" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag
                style="width:130px"
                :type="getDistanceColor(scope.row.distance)"
                effect="plain"
                >+{{ scope.row.distance }} miles away</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            label="Date Request Sent"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.dateSent | moment("MM/DD/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column width="75">
            <template slot-scope="scope">
              <el-tooltip content="Decline" placement="top">
                <el-button
                  class="ts-btn-small invt-action"
                  @click.prevent="deleteInvite(scope.$index, scope.row)"
                  ><i class="fas fa-trash-alt"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot-scope="scope">
              <el-tooltip content="Accept" placement="top">
                <button
                  class="ts-btn ts-btn-small"
                  @click.prevent="acceptConnection(scope.$index, scope.row)"
                >
                  Connect
                </button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-row :gutter="20" class="section-title">
          <el-col :span="24">
            <h6>My Sent Connection Requests</h6>
          </el-col>
        </el-row>
        <p style="padding: 10px;">
          View all the requests that you have sent to a Career Center in order
          to be assigned a staff. If you have not heard back from that Career
          Center in a while, send them a friendly reminder that you want to
          connect.
        </p>
        <el-table
          ref="multipleTable"
          :data="this.SentAgencyRequests"
          stripe
          height="265"
          style="width:100%; margin-top:-20px"
          v-if="!showNoData"
        >
          <el-table-column
            sortable
            property="agencyName"
            label="Career Center Name"
            width="200"
          >
          </el-table-column>
          <el-table-column
            property="zipCode"
            label="Zip Code"
            width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="distance" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag
                style="width:130px"
                :type="getDistanceColor(scope.row.distance)"
                effect="plain"
                >+{{ scope.row.distance }} miles away</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            label="Date Request Sent"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.dateSent | moment("MM/DD/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column width="75">
            <template slot-scope="scope">
              <el-tooltip content="Delete" placement="top">
                <el-button
                  class="ts-btn-small invt-action"
                  @click.prevent="deleteSentRequest(scope.$index, scope.row)"
                  ><i class="fas fa-trash-alt"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot-scope="scope">
              <el-tooltip content="Send Reminders" placement="top">
                <button
                  class="ts-btn ts-btn-small"
                  @click.prevent="sendReminders(scope.$index, scope.row)"
                >
                  Send Reminder
                </button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-row :gutter="20" class="section-title">
          <el-col :span="24">
            <h6>Declined Connections</h6>
          </el-col>
        </el-row>
        <p style="padding: 10px;">
          See the list of previously received and declined requests from Career
          Centers.<br />You can undo this decline by selecting undo
        </p>
        <el-table
          ref="multipleTable"
          :data="this.Declined"
          stripe
          height="265"
          style="width:100%; margin-top:-20px"
          v-if="!showNoData"
        >
          <el-table-column
            sortable
            property="caseWorkerName"
            label="Staff Name"
            width="200"
          >
          </el-table-column>
          <el-table-column
            sortable
            property="agencyName"
            label="Career Center Name"
            width="200"
          >
          </el-table-column>
          <el-table-column
            label="Date Request Sent"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.dateSent | moment("MM/DD/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-tooltip content="Undo" placement="top">
                <el-button
                  class="ts-btn ts-btn-small ts-btn-white"
                  @click.prevent="undoDeclinedRequest(scope.$index, scope.row)"
                >
                  Undo
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    TSLoading
  },
  created() {
    this.isLoading = true;
    this.$store.dispatch("jobseeker/getagencyconnectionrequests").then(res => {
      this.CaseWorkerRequests = res.filter(r => r.status == "Pending");
      this.Declined = res.filter(r => r.status == "Declined");
    });
    this.$store
      .dispatch("jobseeker/getmysentagencyconnectionrequests")
      .then(res => {
        this.SentAgencyRequests = res;
      });

    this.$store
      .dispatch("jobseeker/getcaseworkersearchstatus")
      .then(res => {
        if (res == 1) {
          this.SearchVisibility = "hidden";
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    },
    currentOrganisation() {
      return this.$store.state.organisation.current_organisation
        .OrganisationName;
    },
    employees() {
      return this.$store.state.organisation.current_organisation.Employees.filter(
        e => e.userId !== this.currentUser.Id
      )
        .filter(e => e.queuId !== e.UserId)
        .filter(e => e.id != "NO-USER-EMPLOYEEID");
    }
  },
  data() {
    return {
      isLoading: false,
      CaseWorkerRequests: [],
      SentAgencyRequests: [],
      Declined: [],
      showNoData: false,
      SearchVisibility: "visible"
    };
  },
  methods: {
    deleteInvite(index, row) {
      this.$confirm(
        `Are you sure you want to decline connection request from ${row.agencyName}?`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      )
        .then(() => {
          this.$store
            .dispatch("jobseeker/declineagencyconnectionrequest", row.inviteId)
            .then(res => {
              if (res) {
                this.$store
                  .dispatch("jobseeker/getagencyconnectionrequests")
                  .then(res => {
                    this.CaseWorkerRequests = res.filter(
                      r => r.status == "Pending"
                    );
                    this.Declined = res.filter(r => r.status == "Declined");
                  });
              }
            });
        })
        .catch(() => {});
    },
    acceptConnection(index, row) {
      this.$confirm(
        "By accepting this request, you are confirming the connection to this Career Center, " +
          row.agencyName +
          ".<br/><br/> Do you want to continue?",
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      )
        .then(() => {
          this.isLoading = true;
          var request = {};
          request.connectionRequestId = row.inviteId;
          request.jobSeekerId = this.currentUser.id; // UserId
          request.fullname = this.currentUser.fullName;

          this.$store
            .dispatch("jobseeker/acceptagencyconnectionrequest", request)
            .then(res => {
              if (res) {
                this.$message.success("Connection Accepted!");
                this.$store
                  .dispatch("jobseeker/getagencyconnectionrequests")
                  .then(res => {
                    this.CaseWorkerRequests = res.filter(
                      r => r.status == "Pending"
                    );
                    this.Declined = res.filter(r => r.status == "Deleted");
                  })
                  .catch((error) => {
                    // do error manipulation here
                  })
                  .finally(() => {
                    this.isLoading = false;
                  });
              }
            });
        })
        .catch(() => {});
    },
    undoDeclinedRequest(index, row) {
      this.$confirm(
        "Are you sure you want to undo this decline for a connection request from " +
          row.agencyName +
          '? <br/>This will move the request back into the "Staff Connection Requests" section.',
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      )
        .then(() => {
          this.$store
            .dispatch(
              "jobseeker/undodeclinedagencyconnectionrequest",
              row.inviteId
            )
            .then(res => {
              if (res) {
                this.$store
                  .dispatch("jobseeker/getagencyconnectionrequests")
                  .then(res => {
                    this.CaseWorkerRequests = res.filter(
                      r => r.status == "Pending"
                    );
                    this.Declined = res.filter(r => r.status == "Deleted");
                  });
              }
            });
        })
        .catch(() => {});
    },
    deleteSentRequest(index, row) {
      this.$confirm(
        `Are you sure you want to delete connection request to ` +
          row.agencyName,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      )
        .then(() => {
          this.$store
            .dispatch("jobseeker/deletemysentagencyconnectionrequests", row.id)
            .then(res => {
              if (res) {
                this.$store
                  .dispatch("jobseeker/getmysentagencyconnectionrequests")
                  .then(res => {
                    this.SentAgencyRequests = res;
                  });
              }
            });
        })
        .catch(() => {});
    },
    sendReminders(index, row) {
      this.$store
        .dispatch("jobseeker/sendReminderToAgencyConnection", row.id)
        .then(res => {
          this.$message.success("Reminder is sent!");
        });
    },
    goBack() {
      this.$router.push({ name: "agency-dashboard" });
    },
    getDistanceColor(distance) {
      if (distance > 50 && distance <= 100) {
        return "warning";
      } else if (distance > 100) {
        return "error";
      } else {
        return "success";
      }
    }
  }
};
</script>
<style lang="scss">
.section-title {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  background-color: #e8edf3;
  padding-bottom: 5px;
  margin-bottom: 10px !important;
}

@media screen and (max-width: 759px) {
  .page-subtext {
    text-align: left;
  }
}
</style>
